import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import {CellEditorComponentBase} from '@shared/components/cell-components/cell-component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CrossFieldErrorMatcher, InitialFormFieldErrorMatcher} from '@shared/models/forms.models';
import {OptionItem} from '@shared/models/option-item';
import {getCellEditorSelectionData, ParticleState} from '@shared/store/reducers/particle.reduer';
import {GetCellEditorSelectionDataAction} from '@shared/store/actions/particle.actions';
import {
  isMandatoryField,
  isFormField, isFormMandatoryField
} from '@shared/models/cell-editor-mandatory-helper.model'

@Component({
    standalone: false,
    selector   : 'particle-parenthallmark-dropdown-editor',
  templateUrl: './parent-hallmark-dropdown-cell-editor.component.html',
  styleUrls  : ['./parent-hallmark-dropdown-cell-editor.component.scss']
})
export class ParentHallmarkDropdownCellEditorComponent extends CellEditorComponentBase implements OnInit {
  toolTipText: string;
  form: FormGroup;
  inputForm: any;
  inputFormError: any;
  errorMatcher = new CrossFieldErrorMatcher();
  titleStyle = {};
  dropdownData$: BehaviorSubject<OptionItem[]> = new BehaviorSubject([]);

  constructor (private formBuilder: FormBuilder,
               protected particleStore: Store<ParticleState>,
               protected changeDetectorRef: ChangeDetectorRef) {
    super();
    this.inputFormError = {
      value       : {}
    };
    this.inputForm = this.formBuilder.group({
      value  : ['', Validators.required]
    });
  }

  ngOnInit () {
    this.toolTipText = `Note: If you provide 'Yes' for this Hallmark, please make sure to provide the additional Hallmark details in the relevant Hallmark tab.`;
    if (isFormField(this.fieldDefinition)) {
      if (!isMandatoryField(this.fieldDefinition, this.item)) {
        this.inputForm.controls['value'].clearValidators();
        this.inputForm.updateValueAndValidity();
      }
      if (this.fieldDefinition.metaData && this.fieldDefinition.metaData['IsValid'] && this.fieldDefinition.metaData['IsValid'] === 'No') {
        this.setFieldErrorState();
      }
    }
    if (this.item.cells[this.fieldDefinition.key]) {
      const value = this.getItemValue();
      this.inputForm.controls['value'].setValue(value);
      this.onFormValuesChanged();
    } else {
      // this.item.cells[this.fieldDefinition.key] = <CellValue>{
      //   displayText : '',
      //   value : ''
      // };
    }
    this.inputForm.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    });
    if (this.fieldDefinition.options) {
      this.dropdownData$.next(this.fieldDefinition.options);
    } else {
      this.particleStore.dispatch(new GetCellEditorSelectionDataAction(this.sourceType, this.fieldDefinition.cellEditor));
      this.particleStore.pipe(select(getCellEditorSelectionData)).subscribe(selectionData => {
        this.dropdownData$.next(selectionData);
      });
    }
    this.dropdownData$.subscribe(dropdownData => {
      const value = this.getItemValue();
      this.inputForm = this.formBuilder.group({
        value   : [value, Validators.required],
      });
      this.changeDetectorRef.detectChanges();
    });
    if(this.fieldDefinition.metaData){
      Object.keys(this.fieldDefinition.metaData).forEach(key=>{
        if(key.split('-')[0] === 'Title'){
          let styleKey = key.substring( key.indexOf('-')+1 );
          if(styleKey == 'font-size'){
            styleKey += '.'+this.fieldDefinition.metaData[key].split('-')[1];
            this.titleStyle[styleKey]=this.fieldDefinition.metaData[key].split('-')[0];
          }
          else{
            this.titleStyle[styleKey]=this.fieldDefinition.metaData[key];
          }
        }
      })
    }
  }

  private setFieldErrorState() {
    this.errorMatcher = new InitialFormFieldErrorMatcher();
    setTimeout(() => {
      this.inputForm.controls['value'].setErrors({'incorrect': true});
      this.inputFormError['value'] = {
        customError: true
      };
    }, 200);
  }

  private getItemValue() {
    if (!this.item.cells[this.fieldDefinition.key]) {
      return '';
    }
    let value = this.item.cells[this.fieldDefinition.key].value;
    const option = typeof value === 'boolean' ? this.fieldDefinition.options.find(o => this.getBoolean(o.id) === value ) : this.fieldDefinition.options.find(o => o.id === value);
    if (option) {
      value = option;
    }
    return value;
  }

  getBoolean(id: string) {
    return id === 'true' || id === 'Yes' || id === 'yes';
  }

  onFormValuesChanged () {
    for (const field in this.inputForm) {
      if (!this.inputForm.hasOwnProperty(field)) {
        continue;
      }
      this.inputFormError[field] = {};
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormError[field] = control.errors;
      }
    }
    this.validationChange.emit(this.inputForm.valid);
  }

  onSelectionChange (event) {
    let value = event.value;
    const option = this.fieldDefinition.options.find(o => o === value);
    if (option) {
      value = option.id;
    }
    if (!this.item.cells[this.fieldDefinition.key]) {
      this.item.cells[this.fieldDefinition.key] = {};
    }
    this.item.cells[this.fieldDefinition.key].value = value;
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition});
  }

  isFormMandatoryField(): boolean {
    return isFormMandatoryField(this.fieldDefinition, this.item);
  }
}
